import React, { useCallback } from 'react';
import {
  AppDatePicker,
  AppNotificationAlert,
  AppRemixIcon,
  AppTextArea,
} from '@/layout/AppComponents';
import { useDispatch, useSelector } from 'react-redux';
import { Formik } from 'formik';
import Moment from 'moment';
import * as Yup from 'yup';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import ReactDOMServer from 'react-dom/server';
import Translator from '../../../../../components/helpers/Translator';
import { axiosPath } from '../../../../../../routing/helpers/router';
import errorHandler from '@/layout/components/error/ErrorHandler';

export default function GGCLPlantSelectedCalendar(props) {
  const { obligationID, plantIndex } = props;
  const { moduleBridgeHex } = useParams();
  const dispatch = useDispatch();
  const plant = useSelector(
    (s) => s.currentPage?.plantListTab?.[obligationID][plantIndex]
  );
  const validationSchema = Yup.object().shape({
    date: Yup.string().required(
      ReactDOMServer.renderToString(<Translator file="user" name="user.required" />)
    ),
  });

  const handleSave = useCallback(
    async (payload, { resetForm }) =>
      axios
        .post(
          axiosPath("api_r_user_module_globalLegalCompliance_calendar_add"),
          {
            obligationID,
            plantHex: plant.hex,
            moduleBridgeHex,
            payload,
          }
        )
        .then(() => {
          resetForm();
          AppNotificationAlert({
            title: ReactDOMServer.renderToString(
              <Translator
                file="module-globallegalCompliance"
                name="completed"
              />
            ),
            message: ReactDOMServer.renderToString(
              <Translator
                file="module-globallegalCompliance"
                name="event.added"
              />
            ),
            type: "success",
            duration: 5000,
          });
        })
        .catch((e) => dispatch(errorHandler(e))),
    [plant, obligationID, moduleBridgeHex]
  );

  return (
    <Formik
      initialValues={{
        date: Moment().format('DD/MM/YYYY'),
        description: '',
      }}
      validationSchema={validationSchema}
      validateOnChange={false}
      validateOnBlur={false}
      onSubmit={handleSave}
    >
      {({ handleSubmit, values, setFieldValue, isSubmitting, errors }) => (
        <form onSubmit={handleSubmit}>
          <AppDatePicker
            title={ReactDOMServer.renderToString(
              <Translator
                file="module-globallegalCompliance"
                name="planned.date"
              />
            )}
            value={values.date}
            error={errors.date}
            onChange={(opt) => setFieldValue('date', opt)}
            popperClassName="react-datepicker-popper react-datepicker-popper-1000"
            showMonthDropdown
            showYearDropdown
          />
          <AppTextArea
            title={<Translator file="module-legalCompliance" name="comment" />}
            icon={<AppRemixIcon icon="align-left" noVariants />}
            onChange={(opt) => setFieldValue('description', opt)}
            value={values.description}
          />
          <button
            type="submit"
            className="btn btn-primary btn-xs float-right mt-2"
            disabled={isSubmitting}
            onClick={handleSubmit}
          >
            <Translator file="module-legalCompliance" name="create.event" />
          </button>
        </form>
      )}
    </Formik>
  );
}
